import { render, staticRenderFns } from "./ChangeEmailFormComponent.vue?vue&type=template&id=34b7ebc8&scoped=true&"
import script from "./ChangeEmailFormComponent.vue?vue&type=script&lang=ts&"
export * from "./ChangeEmailFormComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeEmailFormComponent.vue?vue&type=style&index=0&id=34b7ebc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b7ebc8",
  null
  
)

export default component.exports